import { render, staticRenderFns } from "./ButtonReset.vue?vue&type=template&id=1865bb57&scoped=true&"
import script from "./ButtonReset.vue?vue&type=script&lang=js&"
export * from "./ButtonReset.vue?vue&type=script&lang=js&"
import style0 from "./ButtonReset.vue?vue&type=style&index=0&id=1865bb57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1865bb57",
  null
  
)

export default component.exports